<clover-text
  *ngFor="let conversation of conversationList; let pos = index"
  [data]="conversation"
  [index]="pos"
></clover-text>
